<div
    [ngClass]="{
        'w-[1080px]': !isFullScreen(),
        'w-screen': isFullScreen(),
        'h-[600px]': !isFullScreen(),
        'h-screen': isFullScreen(),
        'top-0': isFullScreen(),
        'bottom-0': !isFullScreen(),
        'shadow-lg': !isFullScreen(),
        'rounded-md': !isFullScreen()
    }"
    class="fixed bg-white z-50 left-0 overflow-y-hidden grid col-span-1 grid-rows-[42px_auto] grid-cols-1"
>
    <header
        class="flex space-between items-center w-full px-6 h-16 py-3 border-solid border-b-2 border-b-dat-grey-100"
    >
        <section class="flex items-center w-2/3">
            <button class="bg-white border-none h-4 w-4" (click)="clickClose()">
                <span class="material-symbols-outlined"> arrow_back </span>
            </button>
            <h3 class="font-headline-6-strong h-4 ml-4">Audit</h3>
        </section>
        <section class="w-1/3 flex items-center justify-end">
            <button
                class="bg-white border-none h-12 w-12 w-10"
                (click)="toggleFullScreen()"
            >
                <span class="material-symbols-outlined">
                    {{ isFullScreen() ? 'close_fullscreen' : 'fullscreen' }}
                </span>
            </button>
        </section>
    </header>

    <main class="bg-dat-grey-100">
        <nav>
            <ul class="w-full h-10 flex bg-white justify-stretch">
                @for(table of tableTypes; track table) {
                <li
                    class="h-full w-1/2 flex items-center justify-center cursor-pointer"
                    [class.border-b-2]="currentTable() === table"
                    [class.border-b-dat-blue-500]="currentTable() === table"
                    [class.border-solid]="currentTable() === table"
                    (click)="selectActions(table)"
                >
                    <h3 class="title-large">{{ table }}</h3>
                </li>
                }
            </ul>
        </nav>

        @switch (currentTable()) { @case ('All'){

        <ng-container *ngTemplateOutlet="allActionsTemplate"></ng-container>
        } @case('Event Map'){

        <ng-container *ngTemplateOutlet="eventMap"></ng-container>
        }}
    </main>
</div>

<ng-template #eventMap>
    <iq-builder-iq-builder-audit-tool-dashboard-events
        [dashboardInfo]="dashboardInfo()"
    ></iq-builder-iq-builder-audit-tool-dashboard-events>
</ng-template>

<ng-template #allActionsTemplate>
    <div
        [attr.ui-type]="'action-list-container'"
        class="grid grid-cols-[280px_auto] rounded-md grid-rows-[80px_1fr] h-full overflow-y-hidden"
    >
        <form
            [formGroup]="fg"
            class="col-span-2 grid items-center bg-white grid-cols-4 gap-x-4 px-4 py-2"
        >
            <h3 class="m-6 py-2 px-4 font-headline-6">
                Num Of Actions:
                {{ renderedActionListCards()?.length || 0 | number }}
            </h3>
            <mat-form-field appearance="outline">
                <mat-label>Action Name</mat-label>
                <mat-select [formControlName]="'actionName'">
                    <mat-option>All</mat-option>
                    @for(option of (renderActionOptions() | sortActions); track
                    option.value) {
                    <mat-option
                        [value]="option.value"
                        [attr.ui-type]="'action-list-select'"
                    >
                        {{ option.label }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Search</mat-label>
                <input
                    matInput
                    [formControlName]="'query'"
                    [attr.ui-type]="'action-list-input'"
                />
            </mat-form-field>
            <mat-checkbox [formControlName]="'hasError'">
                Has Errors
            </mat-checkbox>
        </form>

        <section
            class="px-2 py-2 flex col-span-1 flex-col items-center h-full max-h-[800px] overflow-y-scroll"
        >
            @for (card of renderedActionListCards(); track card.id) {
            <div
                (click)="selectAllAction(card)"
                class="px-4 py-4 border-solid border-2 my-2 h-15 w-full bg-white rounded-md cursor-pointer active:bg-dat-blue-200 hover:bg-dat-blue-100"
                [class.border-dat-blue-100]="
                    selectedRenderedAction() !== card.id
                "
                [class.border-dat-blue-500]="
                    selectedRenderedAction() === card.id
                "
            >
                <h3
                    class="title-strong flex items-center"
                    [class.mb-4]="card.additionalInfo.length > 0"
                >
                    <div class="w-full">
                        @if(card.hasError){
                        <span
                            class="material-symbols-outlined text-red-500 mr-2"
                            >error</span
                        >
                        }
                        <iq-builder-label
                            [id]="card.id"
                            [label]="card.name"
                            [shouldTruncate]="true"
                            [type]="'md'"
                        />
                    </div>
                </h3>
                @for(info of card.additionalInfo; track info.id) {
                <p class="body-small-strong">{{ info.label }}</p>
                <p class="body-small">{{ info.value }}</p>
                }
            </div>
            }
        </section>

        <div
            [attr.ui-type]="'action-info-container'"
            class="h-full max-h-[800px] overflow-y-scroll p-4 col-span-1 gap-y-2"
        >
            <div
                [attr.data-uitype]="'card'"
                [class.hidden]="!payload()"
                class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
            >
                <header
                    (click)="toggleTemplate()"
                    class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
                >
                    <h3 class="title-large-strong">Payload Info</h3>
                </header>
                <main class="px-2 mt-2">
                    <pre
                        class="rounded-md p-4 bg-dat-grey-900 text-white max-h-[400px] w-full h-full overflow-y-scroll"
                        >{{ payload() | json }}</pre
                    >
                </main>
            </div>
            @if(traceId()?.length > 0){
            <div
                [attr.data-uitype]="'card'"
                class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
            >
                <header
                    (click)="toggleTemplate()"
                    class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
                >
                    <h3 class="title-large-strong">Event Trace</h3>
                </header>
                <main class="px-2 mt-2">
                    <iq-builder-events-trace
                        [traceId]="traceId()"
                    ></iq-builder-events-trace>
                </main>
            </div>
            }

            <div
                [attr.data-uitype]="'card'"
                [class.opacity-0]="!prerenderedActionInfo()"
                class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
            >
                <header
                    (click)="toggleTemplate()"
                    class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
                >
                    <h3 class="title-large-strong">Template</h3>
                    <span class="material-symbols-outlined">
                        {{
                            showTemplate() ? 'arrow_drop_down' : 'arrow_drop_up'
                        }}
                    </span>
                </header>
                <main [class.hidden]="!showTemplate()" class="px-2 mt-2">
                    <pre
                        class="rounded-md p-4 bg-dat-grey-900 text-white max-h-[400px] w-full h-full overflow-y-scroll"
                        >{{ template()?.template }}</pre
                    >
                </main>
            </div>
            <div
                [attr.data-uitype]="'card'"
                [class.opacity-0]="!prerenderedActionInfo()"
                class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
            >
                <header
                    (click)="toggleTemplateData()"
                    class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
                >
                    <h3 class="title-large-strong">Template Data</h3>
                    <span class="material-symbols-outlined">
                        {{
                            showTemplateData()
                                ? 'arrow_drop_down'
                                : 'arrow_drop_up'
                        }}
                    </span>
                </header>
                <main [class.hidden]="!showTemplateData()">
                    <main class="px-2 mt-2">
                        <pre
                            class="rounded-md p-4 bg-dat-grey-900 text-white max-h-[400px] w-full h-full overflow-y-scroll"
                            >{{ template()?.data | json }}</pre
                        >
                    </main>
                </main>
            </div>
            <div
                [attr.data-uitype]="'card'"
                [class.hidden]="!renderedActionErrorInfo()"
                class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
            >
                <header
                    class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
                >
                    <h3 class="title-large-strong">Rendered Error</h3>
                </header>
                <main>
                    <pre
                        class="rounded-md p-4 bg-dat-grey-900 text-white max-h-[400px] w-full h-full overflow-y-scroll"
                        >{{ renderedActionErrorInfo()?.error }}</pre
                    >
                </main>
            </div>
            <div
                [attr.data-uitype]="'card'"
                [class.hidden]="!filterActionsErrorInfo()"
                class="dat-border-card rounded-md bg-white m-6 py-2 px-4"
            >
                <header
                    class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
                >
                    <h3 class="title-large-strong">Filter Error</h3>
                </header>
                <main>
                    <pre
                        class="rounded-md p-4 bg-dat-grey-900 text-white max-h-[400px] w-full h-full overflow-y-scroll"
                        >{{ filterActionsErrorInfo()?.error }}</pre
                    >
                </main>
            </div>
        </div>
    </div>
</ng-template>
